// Ключ в объекте это pathname, значение query параметр.
// Нужно чтобы не сбрасывать скролл на отдельных страницах.
export const DISABLE_SCROLL_TOP_ROUTES: {
  [key: string]: string[]
} = {
  '/': ['task'],
}

export const BLOCK_SCROLL_TOP_STATE = Object.freeze({
  blockScrollTop: true,
})
